import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPickupAddressSelector } from '../selectors'
import {
  setAddressLine1,
  setAddressLine2,
  setAptSuiteRoom,
  setCity,
  setCountry,
  setCounty,
  setLocation,
  setReferringGPSE,
  setReferringGPSN,
  setReferringUSNG,
  setState,
  setStateIds,
  setZip,
} from '../store/pickupAddress.actions'
import { PickupAddressConstants } from '../store/pickupAddress.constants'
import { IPickupAddressState } from '../store/pickupAddress.types'
import { IHospitalOption, IPickupAddressOptionsState } from '../../options/store/options.types'
import { getPickupAddressOptionsSelector } from '../../options/selectors/pickupAddressOptions.selector'
import { getServiceIdSelector } from '../../user/selectors/getServiceId.selector'
import { OptionsService } from '../../options/services/options.service'
import { ICity, ICountyOption, IStateAndCountiesOptionsResponse } from '../../../common/common.types'
import { initialHospitalOption } from '../store/pickupAddress.reducers'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { calculateReferringUSNG } from './setCalculateReferringUSNG.saga'
import { IPcr } from '../../pcr/store/pcr.types'

export function* setRefHospitalDemographicValues() {
  const { typeValue, otherType }: IPickupAddressState = yield select(getPickupAddressSelector)
  if (typeValue?.id === 2) {
    if (!otherType) {
      yield call(setHospitalDemographicData, initialHospitalOption as IHospitalOption)
    } else if (otherType?.id) {
      yield call(setHospitalDemographicData, otherType as IHospitalOption)
    }
  }
}

export function* setHospitalDemographicData(facility: IHospitalOption, pcr?: IPcr) {
  try {
    const serviceId: string = yield select(getServiceIdSelector)
    const pickupAddressOptionsState: IPickupAddressOptionsState = yield select(getPickupAddressOptionsSelector)
    const { stateOptions, countryOptions } = pickupAddressOptionsState
    const {
      name,
      address1,
      address2,
      city,
      state,
      stateIds,
      zip,
      aptSuiteRoom,
      county,
      country,
      usng,
      matchlat,
      matchlon,
    } = facility

    let cityObj: ICity | null = null
    if (city) cityObj = { name: city, nemsisCode: '' }

    const stateOption = stateOptions.find((stateOption) => stateOption.id === state) || null

    let countyOption: ICountyOption | null = null
    if (county && state) {
      const optionsService = new OptionsService(serviceId)

      const response: IStateAndCountiesOptionsResponse = yield call([optionsService, optionsService.getCountyOptions])
      const { entity } = response

      const filteredCounties = entity.find((obj) => obj.state === String(state))
      countyOption = filteredCounties?.counties.find((option) => option.id === county) || null
    }

    const countryOption = countryOptions.find((countryOption) => countryOption.id === country) || null

    let uSNG = usng || ''
    if (matchlat && matchlon) uSNG = yield call(calculateReferringUSNG, matchlat, matchlon)

    if (pcr?.pcrId) {
      pcr.patient = {
        ...pcr.patient,
        pickupAddress: {
          ...pcr.patient.pickupAddress,
          location: name || '',
          addressLine1: address1 || '',
          addressLine2: address2 || '',
          aptSuiteRoom: aptSuiteRoom || '',
          city: cityObj,
          state: stateOption,
          county: countyOption,
          country: countryOption,
          zip: zip || '',
          referringUSNG: uSNG,
          stateIds,
          referringGPSN: matchlat || '',
          referringGPSE: matchlon || '',
        },
      }
      return
    }

    yield put(setLocation(name || ''))

    yield put(setAddressLine1(address1 || ''))
    yield put(setAddressLine2(address2 || ''))

    yield put(setAptSuiteRoom(aptSuiteRoom || ''))

    yield put(setCity(cityObj))

    yield put(setState(stateOption))

    yield put(setCounty(countyOption))

    yield put(setZip(zip || ''))

    yield put(setCountry(countryOption))

    yield put(setReferringUSNG(uSNG))

    yield put(setStateIds(stateIds))

    if (matchlat && matchlon) {
      yield put(setReferringGPSN(matchlat))
      yield put(setReferringGPSE(matchlon))
      yield put(setReferringUSNG(uSNG))
    } else {
      yield put(setReferringGPSN(''))
      yield put(setReferringGPSE(''))
    }
  } catch (e) {
    yield put(throwPcrException(`Pickup Address - setRefHospitalDemographicData() error: ${e}`))
  }
}

export function* setRefHospitalDemographicValuesSaga() {
  yield takeLatest([PickupAddressConstants.SET_OTHER_TYPE], performWithMutexHOG, setRefHospitalDemographicValues)
}
